import { peopleImage } from "../cdn";

export const RECOMMENDATION_VAIBHAV_BHARDWAJ = {
  name: "Vaibhav Bhardwaj",
  position: "CTO",
  company: "Credit Culture",
  profilePic: peopleImage("credit-culture__vaibhav"),
  linkedIn: "https://www.linkedin.com/in/vbhardwaj7/",
  text: `I got the chance to briefly work with Parmeet and I must say that I enjoyed every single second of that. He is one of the few people (I've worked with) who have a zeal to learn more, can quickly adapt to new technology, is a fast learner, highly productive and more important is honest and humble.

    He has got a very pleasing personality and is very presentable.
    
    Parmeet is self disciplined, can manage and plan his time very efficiently and can deliver tasks on time.
    
    I would like to recommend him as a Full stack developer (JavaScript) who can deliver polished front end applications on ReactJs that are backed by equally capable backend developed in NodeJs (deployed on AWS cloud)
    
    People like him are an asset to any team.`,
};

export const RECOMMENDATION_ELISA_FIORENZANI = {
  name: "Elisa Fiorenzani",
  position: "UX/UI designer",
  company: "Condexo",
  profilePic: peopleImage("condexo__elisa"),
  linkedIn: "https://www.linkedin.com/in/elisafiorenzani/",
  text: `It was a pleasure to work with Parmeet, an honest and reliable Dev!`,
};

export const RECOMMENDATION_SARABJOT_SINGH = {
  name: "Sarabjot Singh",
  position: "Full stack developer",
  company: "Classic Informatics",
  profilePic: peopleImage("classic-informatics__sarabjot-singh"),
  linkedIn: "https://www.linkedin.com/in/sarabjot-singh-a9a694114/",
  text: `Parmeet is a creative developer with fantastic eye for unique and innovative designs in addition to his great problem solving skills and zeal to be acquainted with new inclusions to JS.
  He is an excellent team player who can outshine independently as well.`,
};
export const RECOMMENDATION_PRANAV_BANSAL = {
  name: "Pranav Bansal",
  position: "Software engineer",
  company: "Classic Informatics",
  profilePic: peopleImage("classic-informatics__pranav"),
  linkedIn: "",
  text: `There is no better colleague than Parmeet. He is one of the most dedicated professionals I've worked with and is willing to put that extra help whenever you need it. His expertise as a developer is considerable, and it helped our team come up with more efficient solutions on different projects. He is a great asset to our company.`,
};
export const RECOMMENDATION_NIKHIL_GANGWAR = {
  name: "Nikhil Singh Gangwar",
  position: "Lead developer",
  company: "Classic Informatics",
  profilePic: peopleImage("classic-informatics__nikhil"),
  linkedIn: "https://www.linkedin.com/in/nikhil-singh-gangwar-3b161680/",
  text: `Parmeet was my junior at classic informatics and we have worked closely on numerous task alongside. His attention to detail and eagerness to learn sets him apart from anyone that I have worked with. 

  Parmeet's ability to handle any challenge thrown at him with utmost level of calmness and sincerity makes him an asset for organisation. When it comes to front end I have never seen someone so excited about the things they are developing, Parmeet is keen to make a noticeable impact on anything he picks up. 
  
  He was an remarkable colleague and I still miss working with him. As a lead, Parmeet earns my highest recommendation.`,
};

export const RECOMMENDATION_NAVEEN_DHARNI = {
  name: "Naveen Dharni",
  position: "Senior associate",
  company: "Classic Informatics",
  profilePic: peopleImage("classic-informatics__naveen"),
  linkedIn: "https://www.linkedin.com/in/naveen-dharni/",
  text: `Parmeet is an excellent developer and a great friend, he is really good in React and has been a real gem to our last company. His technical skills are impressive as per his experience. He always makes sure to meet all the deadlines within a given time frame & with the top standards. He is hardworking & dedicated in his work. It is a pleasure and honor to recommend Parmeet to anyone who wants to hire him.`,
};

export const RECOMMENDATION_SUNNY_TYAGI = {
  name: "Sunny Tyagi",
  position: "Full stack developer",
  company: "Classic Informatics",
  profilePic: peopleImage("classic-informatics__sunny"),
  linkedIn: "https://www.linkedin.com/in/sunny-tyagi-05565622a/",
  text: `Parmeet is a good and technical sound is his work. I worked with him on 2 projects and he developed the project proficiently on frontend and backend. I hope to get work opportunities with him in future so we can connect the world together for the betterment.`,
};

export const RECOMMENDATION_PURNIMA_LAMBA = {
  name: "Purnima Lamba",
  position: "Senior associate",
  company: "Classic Informatics",
  profilePic: peopleImage("classic-informatics__purnima"),
  linkedIn: "https://www.linkedin.com/in/purnimalamba/",
  text: `I am pleased to write a letter of recommendation for Parmeet Singh. I highly recommend Parmeet Singh to your organization.

    I have known Parmeet Singh for the past 3 years as he was working with me in the same project at Classic informatics. During our time together, his collaboration and leadership skills were truely impressive, and his UI & design work on a project won glowing reviews from peers and client both.
    
    Parmeet Singh is well equipped to grow from challenges that he is presented with. His strong computer programming skills prepare him beautifully for your company. I strongly endorse making Parmeet Singh a member of your team.`,
};

export const RECOMMENDATION_NEHA_KAPUR = {
  name: "Neha Kapur",
  position: "Project manager",
  company: "Classic Informatics",
  profilePic: peopleImage("classic-informatics__neha"),
  linkedIn: "https://www.linkedin.com/in/nehakapur-pm/",
  text: `I really enjoyed working with Parmeet. Highly recommended for React-based web development projects with the rich user interfaces.

    He is eager to learn and improve in all areas. He has excellent communication and technical skills. He is hard-working, ensures deadlines are duly met, and never compromises with product quality.`,
};

export const RECOMMENDATION_PRASHANT_SAXENA = {
  name: "Prashant Saxena",
  position: "Lead developer",
  company: "Classic Informatics",
  profilePic: peopleImage("classic-informatics__prashant"),
  linkedIn: "https://www.linkedin.com/in/prashant-saxena-fed/",
  text: `He is a good coder and has a humble attitude. His work quality is really good. I got a chance to work with him and we both learnt a lot.`,
};

export const RECOMMENDATION_ASHISH_MEHRA = {
  name: "Ashish Mehra",
  position: "Full stack developer",
  company: "Credit Culture",
  profilePic: peopleImage("credit-culture__ashish"),
  linkedIn: "https://www.linkedin.com/in/mehraas/",
  text: `I've worked with Parmeet for short period of time. He is very skillful frontend developer. He don't limit himself to one thing always love to explore new things and share with others.`,
};

export const RECOMMENDATION_DEEPANSH_BHARGAVA = {
  name: "Deepansh Bhargava",
  position: "Full stack developer",
  company: "Credit Culture",
  profilePic: peopleImage("credit-culture__deepansh"),
  linkedIn: "https://www.linkedin.com/in/deepansh946/",
  text: `I worked with Parmeet in Credit Culture. He possesses great abilities in UI/UX. He always brings new ideas to the table and shows great dedication to work. He'll be a good addition to any team.`,
};

export const RECOMMENDATION_DAVINDER_SINGH = {
  name: "Davinder Singh",
  position: "CEO & co-founder",
  company: "Harmindra International",
  profilePic: peopleImage("harmindra-international__davinder-singh"),
  linkedIn: "",
  text: `It was our pleasure to work with Parmeet. He worked on creating the online identity of our business. He got not just the development of the website done but got the copywriting and product photography work done as well. The website created by him is fast and responsive. It has helped us land many new international clients and increase our sales by a whopping 25%. I would strongly recommend hiring him.`,
};

export const RECOMMENDATION_ELIZABETH_SLAVITT = {
  name: "Elizabeth Slavitt",
  position: "Founder/CEO",
  company: "Speakeasy",
  profilePic: peopleImage("speakeasy__elizabeth"),
  linkedIn: "https://www.linkedin.com/in/elizabethslavitt/",
  text: `
  It's been such a pleasure working with Parmeet. We've been impressed by the quality of his code, his communicativeness, his work ethic, and his passion for making the product intuitive and delightful. We'd recommend him enthusiastically to others and hope to work together again in the future.
  `,
};
export const RECOMMENDATION_ISAAC_DURAND = {
  name: "Isaac Durand",
  position: "Lead engineer",
  company: "Speakeasy",
  profilePic: peopleImage("speakeasy__Isaac"),
  linkedIn: "https://www.linkedin.com/in/isaacdurand/",
  text: `
  We brought Parmeet onto our team to accelerate development of a new product, and he definitely delivered. Parmeet immediately took ownership over all the stories we assigned to him, thinking carefully about the user experience and ensuring that the components he built would function well on both desktop and mobile. He was also an excellent collaborator, eager to share ideas for how we could improve the product and receptive to feedback on his work. Thanks to Parmeet, our MVP release was smooth and on schedule. We will definitely keep him in mind for future projects!
  `,
};

export const RECOMMENDATION_LUKA_SAKUN = {
  name: "Luka Sakun",
  position: "Team lead",
  company: "Jiffy",
  profilePic: peopleImage("jiffy__luka"),
  linkedIn: "https://www.linkedin.com/in/lukasakun/",
  text: `
  I worked with Parmeet for half a year, and I can highly recommend him as an experienced front-end developer and a responsible team member. He can quickly understand an issue or a new codebase and provide a solution.
  `,
};

export const RECOMMENDATION_YOGESH_KUMAR = {
  name: "Yogesh Kumar",
  position: "Senior frontend developer",
  company: "Jiffy",
  profilePic: peopleImage("jiffy__yogesh"),
  linkedIn: "https://www.linkedin.com/in/yjoon45/",
  text: `
  I worked with Parmeet at Jiffy, and he is a dependable frontend developer who delivers high-quality work. He writes clean and easy-to-maintain code and always focuses on good user experience and performance. Parmeet is skilled in JavaScript, TypeScript, React, and modern CSS (SCSS, Tailwind). He works well with the team, takes ownership of his tasks, and can be trusted to deliver. He would be a strong addition to any frontend team.
  `,
};

export const RECOMMENDATION_ROHIT_GULATI = {
  name: "Rohit Gulati",
  position: "Lead frontend engineer",
  company: "Jiffy",
  profilePic: peopleImage("jiffy__rohit"),
  linkedIn: "https://www.linkedin.com/in/rawheatg/",
  text: `
  Parmeet is an all-star frontend developer and a great teammate. I've worked with him on multiple features, and he consistently delivers thoughtful ideas, timely solutions, and pixel-perfect, scalable UI. I'd gladly work with him again!
  `,
};

export const RECOMMENDATION_SAFEER_MALIK = {
  name: "Safeer Malik",
  position: "Project manager",
  company: "Condexo",
  profilePic: peopleImage("condexo__safeer"),
  linkedIn: "https://www.linkedin.com/in/safeer-malik/",
  text: `
  He is a hard working individual with good insight into what makes UX work for the end user. A joy to work with.
  `,
};

export const RECOMMENDATION_JORDAN_IRABOR = {
  name: "Jordan Irabor",
  position: "Senior software engineer",
  company: "Meltwater",
  profilePic: peopleImage("meltwater__jordan"),
  linkedIn: "https://www.linkedin.com/in/jordan-irabor-2b8221144/",
  text: `
  I had the pleasure of working with Parmeet on the same team at Meltwater, and I can confidently say that he is one of the best engineers I've worked with. Parmeet brings an exceptional level of attention to detail, a deep understanding of software engineering, and a curiosity that inspires overall team improvements.
  
  He approaches every sprint with a holistic mindset, considering not just the immediate implementation but also the broader product impact. Parmeet consistently contributes thoughtful design suggestions and explores alternative approaches, clearly outlining trade-offs and helping the team make informed decisions.
  
  He's not one to shy away from challenges and frequently demonstrates leadership through initiative, insight, and collaboration. His ability to balance technical depth with product thinking makes him an invaluable asset to any engineering team.
  `,
};

export const ALL_RECOMMENDATIONS = [
  RECOMMENDATION_ELIZABETH_SLAVITT,
  RECOMMENDATION_VAIBHAV_BHARDWAJ,
  RECOMMENDATION_LUKA_SAKUN,
  RECOMMENDATION_SAFEER_MALIK,
  RECOMMENDATION_ISAAC_DURAND,
  RECOMMENDATION_JORDAN_IRABOR,
  RECOMMENDATION_ROHIT_GULATI,
  RECOMMENDATION_YOGESH_KUMAR,
  RECOMMENDATION_NEHA_KAPUR,
  RECOMMENDATION_DAVINDER_SINGH,
  RECOMMENDATION_ELISA_FIORENZANI,
  RECOMMENDATION_NIKHIL_GANGWAR,
  RECOMMENDATION_NAVEEN_DHARNI,
  RECOMMENDATION_PURNIMA_LAMBA,
  RECOMMENDATION_PRANAV_BANSAL,
  RECOMMENDATION_SUNNY_TYAGI,
  RECOMMENDATION_DEEPANSH_BHARGAVA,
  RECOMMENDATION_ASHISH_MEHRA,
  RECOMMENDATION_PRASHANT_SAXENA,
  RECOMMENDATION_SARABJOT_SINGH,
];
